// Demo Roadmap Data - Proyecto de ejemplo para la demo pública
// Este es un proyecto ficticio de una app de gestión de tareas

export const demoRoadmapData = [
  {
    name: "FASE 1: MVP - Funcionalidades Base",
    tasks: [
      {
        id: "1.1",
        name: "Configuración del proyecto",
        status: "completed",
        description: "Inicializar el proyecto con las tecnologías base: React, Node.js, y base de datos PostgreSQL.",
        tech: "React, Node.js, PostgreSQL",
        time: "2-3 días",
        checklist: [
          { id: 1, text: "Crear repositorio en GitHub" },
          { id: 2, text: "Configurar estructura de carpetas" },
          { id: 3, text: "Instalar dependencias base" },
          { id: 4, text: "Configurar ESLint y Prettier" }
        ]
      },
      {
        id: "1.2",
        name: "Sistema de autenticación",
        status: "completed",
        description: "Implementar registro, login y manejo de sesiones con JWT.",
        tech: "JWT, bcrypt, Cookies",
        time: "1 semana",
        checklist: [
          { id: 1, text: "Registro de usuarios" },
          { id: 2, text: "Login con email/contraseña" },
          { id: 3, text: "Recuperación de contraseña" },
          { id: 4, text: "Protección de rutas" }
        ]
      },
      {
        id: "1.3",
        name: "CRUD de tareas",
        status: "completed",
        description: "Crear, leer, actualizar y eliminar tareas con todas las validaciones necesarias.",
        tech: "REST API, PostgreSQL",
        time: "1 semana",
        checklist: [
          { id: 1, text: "Endpoint crear tarea" },
          { id: 2, text: "Endpoint listar tareas" },
          { id: 3, text: "Endpoint actualizar tarea" },
          { id: 4, text: "Endpoint eliminar tarea" },
          { id: 5, text: "Validaciones de datos" }
        ]
      },
      {
        id: "1.4",
        name: "Interfaz de usuario básica",
        status: "testing",
        description: "Diseñar e implementar la UI principal con lista de tareas y formularios.",
        tech: "React, CSS Modules",
        time: "1 semana",
        checklist: [
          { id: 1, text: "Componente lista de tareas" },
          { id: 2, text: "Formulario crear tarea" },
          { id: 3, text: "Modal editar tarea" },
          { id: 4, text: "Confirmación de eliminación" },
          { id: 5, text: "Diseño responsive" }
        ]
      },
      {
        id: "1.5",
        name: "Sistema de prioridades",
        status: "testing",
        description: "Añadir niveles de prioridad (alta, media, baja) a las tareas con indicadores visuales.",
        tech: "React, CSS",
        time: "3-4 días",
        checklist: [
          { id: 1, text: "Campo prioridad en BD" },
          { id: 2, text: "Selector de prioridad en UI" },
          { id: 3, text: "Colores por prioridad" },
          { id: 4, text: "Filtro por prioridad" }
        ]
      }
    ]
  },
  {
    name: "FASE 2: Organización Avanzada",
    tasks: [
      {
        id: "2.1",
        name: "Categorías y etiquetas",
        status: "testing",
        description: "Sistema de categorías para organizar tareas y etiquetas personalizables.",
        tech: "PostgreSQL, React",
        time: "1 semana",
        checklist: [
          { id: 1, text: "CRUD de categorías" },
          { id: 2, text: "Asignar categoría a tarea" },
          { id: 3, text: "Sistema de etiquetas" },
          { id: 4, text: "Filtros por categoría/etiqueta" }
        ]
      },
      {
        id: "2.2",
        name: "Vista Kanban",
        status: "progress",
        description: "Tablero Kanban con columnas personalizables y drag & drop.",
        tech: "React DnD, Framer Motion",
        time: "1-2 semanas",
        checklist: [
          { id: 1, text: "Columnas por estado" },
          { id: 2, text: "Drag and drop de tareas" },
          { id: 3, text: "Crear columnas personalizadas" },
          { id: 4, text: "Animaciones fluidas" }
        ]
      },
      {
        id: "2.3",
        name: "Fechas de vencimiento",
        status: "progress",
        description: "Añadir fechas límite con recordatorios y vista de calendario.",
        tech: "date-fns, React Calendar",
        time: "1 semana",
        checklist: [
          { id: 1, text: "Selector de fecha en tareas" },
          { id: 2, text: "Vista calendario mensual" },
          { id: 3, text: "Indicador tareas vencidas" },
          { id: 4, text: "Ordenar por fecha" }
        ]
      },
      {
        id: "2.4",
        name: "Subtareas",
        status: "pending",
        description: "Permitir crear subtareas dentro de tareas principales con progreso.",
        tech: "PostgreSQL, React",
        time: "1 semana"
      },
      {
        id: "2.5",
        name: "Búsqueda y filtros avanzados",
        status: "pending",
        description: "Búsqueda full-text y filtros combinados por múltiples criterios.",
        tech: "PostgreSQL Full Text, React",
        time: "4-5 días"
      }
    ]
  },
  {
    name: "FASE 3: Colaboración",
    tasks: [
      {
        id: "3.1",
        name: "Equipos y espacios de trabajo",
        status: "pending",
        description: "Crear equipos e invitar miembros para colaborar en tareas compartidas.",
        tech: "PostgreSQL, Invitations",
        time: "2 semanas"
      },
      {
        id: "3.2",
        name: "Asignación de tareas",
        status: "pending",
        description: "Asignar tareas a miembros del equipo con notificaciones.",
        tech: "React, Email Service",
        time: "1 semana"
      },
      {
        id: "3.3",
        name: "Comentarios en tareas",
        status: "pending",
        description: "Sistema de comentarios con menciones y adjuntos.",
        tech: "WebSockets, File Upload",
        time: "1-2 semanas"
      },
      {
        id: "3.4",
        name: "Historial de actividad",
        status: "pending",
        description: "Log de todas las acciones realizadas en el equipo.",
        tech: "PostgreSQL, Event Sourcing",
        time: "1 semana"
      }
    ]
  },
  {
    name: "FASE 4: Productividad",
    tasks: [
      {
        id: "4.1",
        name: "Temporizador Pomodoro",
        status: "pending",
        description: "Timer integrado con técnica Pomodoro y estadísticas de tiempo.",
        tech: "React, Web Workers",
        time: "1 semana"
      },
      {
        id: "4.2",
        name: "Estadísticas y reportes",
        status: "pending",
        description: "Dashboard con métricas de productividad, gráficos y exportación.",
        tech: "Chart.js, PDF Export",
        time: "2 semanas"
      },
      {
        id: "4.3",
        name: "Plantillas de proyectos",
        status: "pending",
        description: "Crear y usar plantillas predefinidas para iniciar proyectos rápidamente.",
        tech: "PostgreSQL, React",
        time: "1 semana"
      },
      {
        id: "4.4",
        name: "Tareas recurrentes",
        status: "pending",
        description: "Programar tareas que se repiten diaria, semanal o mensualmente.",
        tech: "Cron Jobs, PostgreSQL",
        time: "1 semana"
      }
    ]
  },
  {
    name: "FASE 5: Integraciones",
    tasks: [
      {
        id: "5.1",
        name: "Integración con Google Calendar",
        status: "pending",
        description: "Sincronizar tareas con fechas al calendario de Google.",
        tech: "Google Calendar API",
        time: "1 semana"
      },
      {
        id: "5.2",
        name: "Integración con Slack",
        status: "pending",
        description: "Notificaciones en Slack y comandos para crear tareas.",
        tech: "Slack API, Webhooks",
        time: "1 semana"
      },
      {
        id: "5.3",
        name: "API pública",
        status: "pending",
        description: "API REST documentada para integraciones de terceros.",
        tech: "OpenAPI, Swagger",
        time: "2 semanas"
      },
      {
        id: "5.4",
        name: "Webhooks",
        status: "pending",
        description: "Notificar a servicios externos cuando ocurren eventos.",
        tech: "Node.js, Queue",
        time: "1 semana"
      }
    ]
  },
  {
    name: "FASE 6: Mobile & PWA",
    tasks: [
      {
        id: "6.1",
        name: "Progressive Web App",
        status: "pending",
        description: "Convertir la app en PWA con soporte offline y notificaciones push.",
        tech: "Service Workers, IndexedDB",
        time: "2 semanas"
      },
      {
        id: "6.2",
        name: "App móvil nativa",
        status: "pending",
        description: "Aplicación nativa para iOS y Android con React Native.",
        tech: "React Native, Expo",
        time: "4-6 semanas"
      },
      {
        id: "6.3",
        name: "Sincronización offline",
        status: "pending",
        description: "Trabajar sin conexión y sincronizar cambios al reconectar.",
        tech: "IndexedDB, Sync API",
        time: "2 semanas"
      }
    ]
  }
];
